import Recipecard from './components/recipe-card.vue';
import Recipe from './components/recipe.vue';
import FavouriteWidget from './components/favourite-widget.vue';

import Datepicker from 'vuejs-datepicker';
import PlannerWidget from './components/planner-widget.vue';

//register globally to allow access to child components
Vue.component('Datepicker', Datepicker);
Vue.component('PlannerWidget', PlannerWidget);
Vue.component('FavouriteWidget', FavouriteWidget);

window.vueRecipeList = new Vue({

	name: 'recipeList',

	el: '#recipe-list-app',

	data: {

		loading: true,

		free_recipes: pageData.free_recipes ? pageData.free_recipes : false,

		recall_scroll_position: null,

		recipe: pageData.recipe ? pageData.recipe : false,
		recipes: [],

		thinking: false,
		ticking: false,

		//filter options
		pregnant_filter: coreHelpers.getNested(pageData, 'preferences', 'pregnant') && (coreHelpers.getNested(pageData, 'preferences', 'trimester') && pageData.preferences.trimester < 4) ? true : false,

		favourites_filter: false,
		filter_tab_selected: null,

		categories: pageData.categories,
		types: pageData.types,
		dietary_preferences: pageData.dietary_preferences,

		//selected filters
		selected_categories: pageData.category ? [pageData.category.term_id] : [],
		selected_types: [],
		selected_dietary_preferences: [],

		//saved dietary preference
		// selected_dietary_preference: coreHelpers.getNested(pageData, 'preferences', 'dietary_preference_selected') ? [pageData.preferences.dietary_preference_selected] : [],

		filter_message: false,
		filter_message_image: 'info',
		filter_recall_message: false,

		load_saved_filters: pageData.ignoreSavedFilters === false ? false : true, //default to true unless disabled

		//lazy loading
		enable_lazy_loading: pageData.lazyLoading === false ? false : true, //default to true unless disabled
		lazy_load: false,
		next_page: 2, //set to 2 as the page is loaded with page one populated
		max_num_pages: null,

		//personalisation
		pregnant: coreHelpers.getNested(pageData, 'preferences', 'pregnant') ? true : false,
		pregnant_due_date: coreHelpers.getNested(pageData, 'preferences', 'pregnant_due_date') ? pageData.preferences.pregnant_due_date : false,
		timester: coreHelpers.getNested(pageData, 'preferences', 'trimester') ? pageData.preferences.trimester : false,

		//meal-prep
		meal_prep: pageData.meal_prep ? true : false,

		logged_in: coreHelpers.getNested(pageData, 'logged_in'),

	},

	computed: {

		current_filter_options() {

			switch (this.filter_tab_selected) {
				case 'category':
					return this.categories;
				case 'type':
					return this.types;
				case 'dietary_preferences':
					return this.dietary_preferences;
				default:
					return [];
			}

		},

		all_selected_filters() {

			return this.selected_categories.concat(this.selected_types).concat(this.selected_dietary_preferences);

		}

	},

	watch: {

		all_selected_filters() {

			console.log('watch all_selected_filters triggered')

			this.getRecipes();

		},

		/* selected_category() {

			// this.saveFilters()
			this.getRecipes();
		},

		selected_type() {

			// this.saveFilters()
			this.getRecipes();

		},

		selected_dietary_preference() {

			// this.saveFilters()
			this.getRecipes();

		}, */

		favourites_filter() {

			console.log('watch favourites_filter triggered')

			this.getRecipes();

		},

		pregnant_filter() {

			console.log('watch pregnant_filters triggered')

			coreVariables.triggerModal('Pregnancy mode', 'Pregnancy mode is now ' + (this.pregnant_filter ? 'switched on' : 'switched off'));
			this.getRecipes();

		}

	},

	components: {

		Recipecard,
		Recipe
	},

	mounted() {

		//logic used to determine whether videos will be loaded via ajax after initial query
		this.recipes = (this.selected_category === '' && this.load_saved_filters) ? [] : pageData.wp_query;

		if (this.recipes.length) {

			this.loading = false;
		}

		if (!this.meal_prep && !this.free_recipes) {

			this.personalise();
			// this.loadFilters();

		}

		//infinite scroll / laxy load
		window.addEventListener('scroll', function(e) {

			if (!window.vueRecipeList.ticking && !window.vueRecipeList.thinking) {

				window.requestAnimationFrame(function() {

					let scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

					if (scroll + window.innerHeight >= (document.documentElement.offsetHeight - 1000)) {

						window.vueRecipeList.getRecipes(true);

					}

					window.vueRecipeList.ticking = false;
				});

				window.vueRecipeList.ticking = true;
			}
		});

	},

	methods: {

		filter_click(clicked_option) {

			if(clicked_option === this.filter_tab_selected) {

				this.filter_tab_selected = null;

			}

			else {

				this.filter_tab_selected = clicked_option;

			}

		},

		add_or_remove_filter_option(clicked_option) {

			console.log(clicked_option);

			let selector;

			switch (clicked_option.taxonomy) {
				case "category_recipe":
					selector = 'selected_categories';
					break;
				case "category-btb-recipe":
					selector = 'selected_categories';
					break;
				case "type":
					selector = 'selected_types';
					break;
				case "btb-type":
					selector = 'selected_types';
					break;
				case "dietary-preference":
					selector = 'selected_dietary_preferences';
					break;
			}

			if(this[selector].filter(option => option.term_id === clicked_option.term_id).length) {

				//remove
				this[selector] = this[selector].filter(option => option !== clicked_option);
				clicked_option.selected = false;


			}
			else {

				//add
				this[selector].push(clicked_option);
				clicked_option.selected = true;

			}

		},

		getRecipes(lazyLoad = false) {

			let scroll_position = false;

			if (!this.free_recipes && localStorage.getItem('recipe-index')) {

				this.recall_scroll_position = true;
				scroll_position = localStorage.getItem('recipe-index');

				//delete the index
				localStorage.removeItem('recipe-index');

			}

			if (lazyLoad && this.enable_lazy_loading === false) {

				this.thinking = false;
				return false;

			}

			this.thinking = true;

			if (lazyLoad) {

				// this.next_page++;
				this.lazy_load = true;

			}

			//else this is the first load
			else {

				this.lazy_load = false;
				this.next_page = 1; //set to first page
				this.max_num_pages = null;
				this.filter_message_image = 'info';
				this.filter_message = 'Searching...';

			}

			if (this.max_num_pages && this.next_page >= this.max_num_pages) {

				this.thinking = false;
				return false;

			}

			let getRecipeFunctionName = 'lc_get_recipes';

			if (this.free_recipes) {

				getRecipeFunctionName = 'lc_get_free_recipes'

			}

			coreHelpers.ajax('POST', getRecipeFunctionName, {

				'categories': this.selected_categories.map(option => option.term_id),
				'types': this.selected_types.map(option => option.term_id),
				'preferences': this.selected_dietary_preferences.map(option => option.term_id),
				'page': this.next_page,
				'fav': this.favourites_filter,
				'pregnant': this.pregnant_filter,
				'recall_position': scroll_position,

			}, this.getRecipesCallback, this.getRecipesFailureCallback);

		},

		getRecipesCallback(res) {

			this.thinking = false;

			this.max_num_pages = res.data.max_num_pages;

			if (res.success === true) {

				if (this.lazy_load) {

					this.next_page++;
					this.recipes = this.recipes.concat(res.data.recipes);

				} else {

					this.filter_message_image = 'success';
					this.filter_message = 'Found ' + res.data.total_posts + ' recipes';
					this.recipes = res.data.recipes;

					//this will only happen on initial load
					if (res.data.recall_position) {

						//set the correct number of pages loaded
						this.next_page = this.next_page + res.data.recall_number_of_pages;

						//adjust the max number of pages based on the default settings
						this.max_num_pages = res.data.total_posts / res.data.posts_per_page;

						//scroll into view
						Vue.nextTick(() => {

							let yOffset = -10;

							if (coreVariables.viewPortWidth > 767) {

								yOffset = -60;

							}

							let el = document.querySelector('[data-index="' + res.data.recall_position + '"]');

							if (el) {

								let y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
								window.scrollTo({ top: y, behavior: 'smooth' });

							}

						});

					}
				}

				this.loading = false;

			} else {

				coreVariables.triggerModal('Slight problem', 'Something has gone wrong, please try again later');
			}

		},

		getRecipesFailureCallback(res) {

			this.thinking = false;

			coreVariables.triggerModal('Slight problem', 'Something has gone wrong, please try again later');

		},

		/* saveFilters() {

			//dont' save for free recipes
			if (this.free_recipes) { return false; }

			let filters = {

				'selected_category': this.selected_category,
				'selected_type': this.selected_type,
				'selected_dietary_preference': this.selected_dietary_preference,

			}

			localStorage.setItem('lcRecipeFilters', JSON.stringify(filters));

		}, */

		/* loadFilters() {

			//only load filters if the category hasn't been populated by url
			if (this.selected_category === '' && this.load_saved_filters) {

				let savedFilters = localStorage.getItem('lcRecipeFilters');

				if (savedFilters && !this.free_recipes) {

					savedFilters = JSON.parse(savedFilters);
					this.selected_category = savedFilters.selected_category ? savedFilters.selected_category : '';
					this.selected_type = savedFilters.selected_type ? savedFilters.selected_type : '';

					if (savedFilters.selected_category || savedFilters.selected_type || (savedFilters.selected_dietary_preference && !this.selected_dietary_preference)) {

						this.filter_recall_message = true;

					}

					//show selected preference unless set in personalisation
					this.selected_dietary_preference = this.selected_dietary_preference ? this.selected_dietary_preference : savedFilters.selected_dietary_preference;

					if (savedFilters.selected_category === '' && savedFilters.selected_type === '' && savedFilters.selected_dietary_preference === '') {

						this.getRecipes();

					}

				} else {

					this.getRecipes();
				}
			}

		}, */

		personalise() {

			if (!this.free_recipes) {

				if(coreHelpers.getNested(pageData, 'preferences', 'dietary_preference_selected')) {

					this.selected_dietary_preferences.push(this.dietary_preferences.filter(pref => parseInt(pref.term_id) === parseInt(pageData.preferences.dietary_preference_selected))[0])

				}
			}

		}
	}
});